var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"popupView",staticClass:"popup-view",style:({ left: _vm.leftPos + _vm.left + 'px', top: _vm.topPos + _vm.top + 'px' })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }